import { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full pb-16 md:pb-0">
        <Outlet />
      </main>
      <Footer />

      <Link
        to="/"
        className="md:hidden fixed bottom-4 right-4 z-40 flex items-center gap-2 bg-primary-700 text-background-50 text-sm px-4 h-11 rounded-full whitespace-nowrap cursor-pointer"
      >
        <i className="ri-home-4-line"></i>
        返回首页
      </Link>
    </div>
  );
}